import { setRemoteDefinitions } from '@nx/angular/mf';
import { environment } from 'environments/environment';

const fileName = environment.production ? 'module-federation.manifest.prod.json' : 'module-federation.manifest.json';

fetch(`/assets/${fileName}`)
  .then(async res => res.json())
  .then(definitions => {
    return Object.entries(definitions).reduce<Record<string, string>>((acc, [key, value]) => {
      acc[key] = `${value}/remoteEntry.mjs?ts=${new Date().getTime()}.js`;
      return acc;
    }, {});
  })
  .then(definitions => setRemoteDefinitions(definitions))
  .then(async () => import('./bootstrap').catch(err => console.error(err)));
